

// import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// import axiosInstance from 'Services/APIService';
// import {
//   ManagersPayload,
//   ManagersState,
//   StaffResponse
// } from '../../../types/ndisSection/managersListTypes';

// // Initial state
// const initialState: ManagersState = {
//   managers: [],
//   fullStaff: null,
//   loading: false,
//   error: null
// };

// // Async thunk to fetch managers
// export const fetchManagers = createAsyncThunk(
//   'managers/fetchManagers',
//   async (payload: ManagersPayload, { rejectWithValue }) => {
//     try {
//       // Process payload as per requirements
//       const processedPayload = {
//         group_id: payload.group_id,
//         service_name_id: payload.service_name_id.replace(/\s/g, '_'),
//         nested_component_id: payload.nested_component_id,
//         email_loggedIn_userEmail: payload.email,
//         approved_user: payload.email.split('@')[0].replace(/\./g, '_'),
//         curr_loggIn_userRoles: payload.roles,
//         client_name: payload.client_name.replace(/\s/g, '_')
//       };

//       const response = await axiosInstance.post('/staff/details', processedPayload);
//       const data: StaffResponse = response.data;
//       // Return Manager array for managers state and store full response
//       return {
//         managers: data.participants_list.Manager,
//         fullStaff: data
//       };
//     } catch (error: any) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to fetch managers');
//     }
//   }
// );

// // Create the slice
// const managersSlice = createSlice({
//   name: 'managers',
//   initialState,
//   reducers: {
//     clearManagers: (state) => {
//       state.managers = [];
//       state.fullStaff = null;
//       state.error = null;
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchManagers.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchManagers.fulfilled, (state, action) => {
//         state.loading = false;
//         state.managers = action.payload.managers;
//         state.fullStaff = action.payload.fullStaff;
//       })
//       .addCase(fetchManagers.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       });
//   }
// });

// // Export actions
// export const { clearManagers } = managersSlice.actions;

// // Export reducer
// export default managersSlice.reducer;

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';
import {
  ManagersPayload,
  ManagersState,
  StaffResponse
} from '../../../types/ndisSection/managersListTypes';

// Initial state
const initialState: ManagersState = {
  managers: [],
  fullStaff: null,
  loading: false,
  error: null
};

// Async thunk to fetch managers
export const fetchManagers = createAsyncThunk(
  'managers/fetchManagers',
  async (payload: ManagersPayload, { rejectWithValue }) => {
    try {
      // Process payload as per requirements
      const processedPayload = {
        group_id: payload.group_id,
        service_name_id: payload.service_name_id.replace(/\s/g, '_'),
        nested_component_id: payload.nested_component_id,
        email_loggedIn_userEmail: payload.email,
        approved_user: payload.email.split('@')[0].replace(/\./g, '_'),
        curr_loggIn_userRoles: payload.roles,
        client_name: payload.client_name.replace(/\s/g, '_')
      };

      const response = await axiosInstance.post('/staff/details', processedPayload);
      const data: StaffResponse = response.data;
      // Return Manager array for managers state and store full response
      return {
        managers: data.participants_list.Manager,
        fullStaff: data
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch managers');
    }
  }
);

// Async thunk to delete manager
export const deleteManager = createAsyncThunk(
  'managers/deleteManager',
  async (
    payload: {
      group_id: string;
      service_name_id: string;
      staff_email: string;
      client_email: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.post('/ndis/delete-client/employees', {
        group_id: payload.group_id,
        service_name_id: payload.service_name_id.replace(/\s/g, '_'),
        staff_email: payload.staff_email,
        client_email: payload.client_email
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to delete manager');
    }
  }
);

// Create the slice
const managersSlice = createSlice({
  name: 'managers',
  initialState,
  reducers: {
    clearManagers: (state) => {
      state.managers = [];
      state.fullStaff = null;
      state.error = null;
    },
    removeManager: (state, action) => {
      state.managers = state.managers.filter((manager) => manager.email !== action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchManagers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchManagers.fulfilled, (state, action) => {
        state.loading = false;
        state.managers = action.payload.managers;
        state.fullStaff = action.payload.fullStaff;
      })
      .addCase(fetchManagers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(deleteManager.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteManager.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
});

// Export actions
export const { clearManagers, removeManager } = managersSlice.actions;

// Export reducer
export default managersSlice.reducer;